interface UomOption {
  uoMName: string;
  isActive: boolean;
}

export function isActiveUom(uoms: readonly UomOption[], name: string): boolean {
  return uoms.some((uom) => uom.uoMName === name && uom.isActive === true);
}

export function getSelectableUoms<T extends UomOption>(
  uoms: readonly T[],
  current?: T | null,
): T[] {
  const options = uoms.filter((uom) => uom.isActive === true);
  if (current && !options.some((uom) => uom.uoMName === current.uoMName)) {
    options.push(current);
  }
  return options;
}

export function getSelectableUomNames(
  uoms: readonly UomOption[],
  currentName?: string | null,
): string[] {
  const names = uoms
    .filter((uom) => uom.isActive === true)
    .map((uom) => uom.uoMName);

  // Keep historical values displayable without making other inactive units selectable.
  if (currentName && !names.includes(currentName)) {
    names.push(currentName);
  }

  return names;
}
